export default __webpack_public_path__ + "static/media/down-solid.903eaa19.svg";